import { render, staticRenderFns } from "./VSkeletonPDF.vue?vue&type=template&id=f32101cc"
import script from "./VSkeletonPDF.vue?vue&type=script&lang=js"
export * from "./VSkeletonPDF.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports